// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__dNipE","toggle":"Menu_toggle__o93PC"};